<script>
  import { _ } from './services/i18n'
</script>

<main class="main" id="home">
  <div class="hero-text">
    <h1>{$_('hero.title')}<br /><span>{$_('hero.title2')}</span></h1>
    <p>{$_('hero.subtitle')}</p>
  </div>
</main>

<style>
  .main {
    background-image: url('../assets/mainPic.jpg');
    background-image: url('../assets/girlMain.avif');
    background-image: url('../assets/brook2.jpg');
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    background-size: cover;
    height: 100vh;
    width: 100vw;
    padding: 2rem;
    animation: fadeIn 1s linear forwards;
  }
  .hero-text {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
  .hero-text h1 {
    color: var(--headerColor);
    font-size: 4rem;
    margin-top: 8rem;
    padding-bottom: 0.5rem;
  }
  .hero-text span {
    color: var(--headerColor);
  }
  .hero-text p {
    color: var(--mainWhite);
    font-size: 1.35rem;
  }
  @keyframes fadeIn {
    0% {
      transform: translateX(-100%);
      opacity: 0;
    }
    100% {
      transform: translateX(0%);
      opacity: 1;
    }
  }
  @media (max-width: 768px) {
    .main {
      padding: 2rem 1rem;
    }
    .hero-text {
      text-align: center;
    }
    .hero-text h1 {
      margin-top: 4rem;
      font-size: 3.5rem;
    }
    .hero-text p {
      width: 100%;
    }
  }

  @media (max-width: 540px) {
    .hero-text h1 {
      font-size: 3rem;
    }
    .hero-text p {
      font-size: 1.1rem;
    }
  }
</style>
